/**
 * Shared time-grid utilities used across Atelier, Reception, and Disponibilités screens.
 */

/** Snap a decimal hour to the nearest grid increment */
export function snapToGrid(hour: number, snapUnit: number): number {
  return Math.round(hour / snapUnit) * snapUnit;
}

/** Format a decimal hour as "8h00", "9h15", etc. */
export function formatTime(h: number): string {
  let hours = Math.floor(h);
  let mins = Math.round((h - hours) * 60);
  if (mins === 60) { hours += 1; mins = 0; }
  return `${hours}h${mins.toString().padStart(2, "0")}`;
}

/** Convert decimal hour to HH:MM string (e.g. 8.25 → "08:15") */
export function hourToTimeStr(h: number): string {
  let hours = Math.floor(h);
  let mins = Math.round((h - hours) * 60);
  if (mins === 60) { hours += 1; mins = 0; }
  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
}

/** Convert HH:MM string to decimal hour (e.g. "08:15" → 8.25) */
export function timeStrToHour(s: string): number {
  const [h, m] = s.split(":").map(Number);
  return h + m / 60;
}

/** Format a date string (YYYY-MM-DD) + optional decimal hour as "12/04 à 9h30" */
export function formatDateHour(dateStr: string | null, hour?: number | null): string {
  if (!dateStr) return "—";
  const [, m, d] = dateStr.split("-");
  const datePart = `${d}/${m}`;
  if (hour == null) return datePart;
  const hrs = Math.floor(hour);
  const mins = Math.round((hour - hrs) * 60);
  return `${datePart} à ${hrs}h${mins.toString().padStart(2, "0")}`;
}

/** Position a fixed tooltip so it never overflows the viewport.
 *  Tries to place it to the right of the parent, falls back to left.
 */
export function positionTooltip(el: HTMLElement): void {
  const parent = el.parentElement;
  if (!parent) return;
  const rect = parent.getBoundingClientRect();
  const tw = el.offsetWidth;
  const th = el.offsetHeight;
  let top = rect.top;
  let left = rect.right + 8;
  if (left + tw > window.innerWidth - 8) {
    left = rect.left - tw - 8;
  }
  if (left < 8) left = 8;
  if (top + th > window.innerHeight - 8) {
    top = window.innerHeight - th - 8;
  }
  if (top < 8) top = 8;
  el.style.top = `${top}px`;
  el.style.left = `${left}px`;
}
